import React from "react";
import MatchProfilesList from "../../MatchProfiles/MatchProfilesList";

const MatchProfiles = () => {
  return (
    <>
      <div className={"mb-2"}>
        <MatchProfilesList />
      </div>
    </>
  );
};

export default MatchProfiles;
